import type { FC } from 'react';
import type { TFunction } from 'i18next';
import { Flex } from 'antd';

import type { AgentField } from '@shared/api';
import { Text } from '@shared/ui/antd';
import { Fields } from '../fields/fields';

import styles from '../../prompt.module.scss';

interface RequiredFieldsProps {
  agentId: number;
  agentFields: AgentField[];
  t: TFunction<'translation', 'prompt'>;
}

export const RequiredFields: FC<RequiredFieldsProps> = ({ agentId, agentFields, t }) => (
  <Flex vertical className={styles.element} gap={16}>
    <Flex gap={4} align="start" vertical>
      <Text variant="md" fontWeight={500}>
        {t('goal')}
      </Text>

      <Text variant="sm" style={{ color: 'var(--color-text-tertiary)' }}>
        {t('goalDescription')}
      </Text>
    </Flex>

    <Fields agentId={agentId} agentFields={agentFields} />
  </Flex>
);
